<script>
import {KEY_CODE} from "../../../constants/keycodes";
import {predefinedKey} from "../../../plugins/common/input/predefined-key";

export default {
    name: "ComponentTableKeyHelper",
    data() {
        return {
        };
    },
    computed: {
        formTable() {
            return this.$refs.componentTable.querySelector(".form-table");
        },
    },
    methods: {
        /**
         * 개별 컴포넌트의 td keypress 이벤트 발생에 대한 처리를 합니다.
         */
        onKeydownTd(e) {
            if (predefinedKey.isArrowKey(e.keyCode)) {
                e.preventDefault(); // 방향키 입력시 정의된 기본행동(스크롤)을 막습니다.
                e.stopPropagation();
                this.keypressArrow(e.keyCode, this.editableCols);
            }
        },

        onKeydownTr(e) {
            if (predefinedKey.isArrowKey(e.keyCode)) {
                e.preventDefault(); // 방향키 입력시 정의된 기본행동(스크롤)을 막습니다.
                this.keypressArrow(e.keyCode, 1);
            }
        },

        /**
         * arrow 키가 press 될 때 tabable 한 엘리먼트사이에서 focus 를 적절히 전환합니다.
         */
        keypressArrow(keyCode, tabableCols = 1) {
            const focussable = Array.prototype.filter.call(document.querySelectorAll(".tabable"),
                e => e.tabIndex === document.activeElement.tabIndex
            );
            const index = focussable.indexOf(document.activeElement);
            if (index > -1) {
                let nextElement;
                switch (keyCode) {
                    case KEY_CODE.ARROW_LEFT:
                        nextElement = focussable[index - 1] || undefined;
                        break;
                    case KEY_CODE.ARROW_TOP:
                        this._scrollTopToFocusingElement();
                        nextElement = focussable[index - tabableCols] || undefined;
                        break;
                    case KEY_CODE.ARROW_RIGHT:
                        nextElement = focussable[index + 1] || undefined;
                        break;
                    case KEY_CODE.ARROW_BOTTOM:
                        nextElement = focussable[index + tabableCols] || undefined;
                        break;
                    default:
                        break;
                }
                nextElement && nextElement.focus()
            }
        },

        /**
         * 위로갈때는 scrollTop 을 적절히 유지시켜줍니다.
         */
        _scrollTopToFocusingElement() {
            this.formTable.scrollTo(this.formTable.scrollLeft, 0);
        },
    }
}
</script>